import React, { useState, useEffect } from "react";
import moment from "moment";
import classes from "./Countdown.module.css"

const Countdown = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = moment();
    const target = moment(targetDate);
    const duration = moment.duration(Math.max(0, target.diff(now)));
    return {
      days: Math.floor(duration.asDays()),
      hours: duration.hours(),
      minutes: duration.minutes(),
      seconds: duration.seconds(),
    };
  }

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    <div className={classes.main}>
      <h1>
        До початку події
      </h1>
      <p>
        {timeLeft.days} дн · {timeLeft.hours} год · {timeLeft.minutes} хв · {timeLeft.seconds} с
      </p>
    </div>
  );
};

export default Countdown